import React, {useEffect, useState} from 'react'
import styled from '../Payment/style.module.scss'
import {
    CardCvcElement,
    CardExpiryElement,
    CardNumberElement,
    useElements,
    useStripe
} from '@stripe/react-stripe-js'
import s from './style.module.scss'
import {useDispatch, useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import PATH from '../pathConst'
import {useHistory} from 'react-router'
import {billingStepProcess} from '../../../../../redux/actions/subscription';
import {RootState} from '../../../../../redux/reducers'
import {subscriptionsAPI} from "../../../../../api/api";
import {useTranslation} from "react-i18next";
type Props = {
    tariff: any;
    authToken: string;
}

const ContactInfo = ({tariff, authToken}: Props) => {

    const {t} = useTranslation()
    const stripe: any = useStripe()
    const elements: any = useElements()
    const statusBilling = useSelector((state: RootState) => state.subscriptionReducer.isStatus)
    const dispatch = useDispatch()
    const history = useHistory()
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [paymentError, setPaymentError] = useState('')

    useEffect(() => {
        if (statusBilling === 0) {
            let path = `4`
            history.push(path)
        } else if (statusBilling === 1) {
            let path = '5'
            history.push(path)
        }
    }, [history, statusBilling])

    const getPaymentErrorMessage = (data?: any) => {
        const code = data?.decline_code || data?.error_code

        if (code === 'card_declined' || data?.error_code === 'card_declined') {
            return t(
                'billing.payment.errorDeclined',
                'The payment was declined by Stripe. Please try another card or contact your bank.'
            )
        }

        if (data?.payment_status === 'requires_payment_method') {
            return t(
                'billing.payment.errorPaymentMethod',
                'The payment did not go through. Please check the card details or use another card.'
            )
        }

        if (data?.payment_status === 'requires_action') {
            return t(
                'billing.payment.errorVerification',
                'Additional card verification is required. Please complete verification and try again.'
            )
        }

        return data?.message || t(
            'billing.payment.errorGeneric',
            'The payment was not completed. Please try again or use another card.'
        )
    }

    const withTimeout = (promise: Promise<any>) => {
        return Promise.race([
            promise,
            new Promise((_, reject) => {
                window.setTimeout(() => reject(new Error('payment_timeout')), 45000)
            })
        ])
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault()
        setPaymentError('')

        if (!stripe || !elements) {
            setPaymentError(t('billing.payment.errorNotReady', 'The payment form is still loading. Please try again in a moment.'))
            return
        }

        setIsSubmitting(true)

        try {
            const cardElement = elements.getElement(CardNumberElement);
            const payload = await stripe.createToken(cardElement);

            if (payload.error || !payload.token) {
                setPaymentError(payload.error?.message || t('billing.payment.errorCard', 'Please check your card details.'))
                return
            }

            const response: any = await withTimeout(
                subscriptionsAPI.sendStripe(authToken, payload.token.id, tariff.id, tariff.id)
            );
            const data = response.data.data || {}
            const paymentIntent = data.latest_invoice?.payment_intent

            if (paymentIntent?.status === 'requires_action') {
                const confirmation = await stripe.confirmCardPayment(paymentIntent.client_secret);

                if (confirmation.error) {
                    setPaymentError(confirmation.error.message || getPaymentErrorMessage({payment_status: 'requires_action'}))
                    return
                }

                if (confirmation.paymentIntent?.status !== 'succeeded') {
                    setPaymentError(getPaymentErrorMessage({payment_status: confirmation.paymentIntent?.status}))
                    return
                }
            } else if (response.data.status !== 0) {
                setPaymentError(getPaymentErrorMessage(data))
                return
            } else if (paymentIntent && paymentIntent.status !== 'succeeded') {
                setPaymentError(getPaymentErrorMessage({
                    ...data,
                    payment_status: paymentIntent.status
                }))
                return
            }

            dispatch(billingStepProcess(0));
        } catch (error: any) {
            setPaymentError(
                error?.message === 'payment_timeout'
                    ? t('billing.payment.errorTimeout', 'The payment is taking too long. Please check your subscription status before trying again.')
                    : t('billing.payment.errorNetwork', 'We could not confirm the payment. Please try again in a moment.')
            )
        } finally {
            setIsSubmitting(false)
        }
    }

    return <>
        <div className={s.cardWrapper}>
            <form>
                {t('billing.payment.cardNumber', 'Card number')}
                <CardNumberElement className={s.cardNumber}/>
                <div className={s.expiryAndCvc}>
                    <div>
                        {t('billing.payment.expirationDate', 'Expiration date')}
                        <CardExpiryElement className={s.cardExpiry}/>
                    </div>
                    <div>
                        CVC
                        <CardCvcElement className={s.cardCVC}/>
                    </div>
                </div>
                <div>
                    {t('billing.payment.cardholderName', 'Cardholder name')}
                    <input
                        type="text"
                        placeholder={t('billing.payment.nameOnCard', 'Name on card')}
                        className={s.cardPerson}
                    />
                </div>
            </form>

            <div className={s.checkout}>
                <div className={s.checkoutTitle}>{t('billing.payment.toPay', 'To pay')}<br/>
                    <span>{t('billing.payment.plan', 'Plan')} {tariff.title}</span>
                </div>
                <div className={s.price}>{tariff.price} $</div>
            </div>
        </div>
        {paymentError && <div className={s.paymentError}>{paymentError}</div>}
        <div className={styled.bottomButtons}>
            <div className={styled.buttonBack}><Link to={`${PATH}`}>{t('btn.back', 'Back')}</Link></div>
            <div className={styled.buttonSubmit}>
                <button type="button" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? t('billing.payment.processing', 'Processing...') : t('btn.pay', 'Pay')}
                </button>
            </div>
        </div>
    </>
};

export default ContactInfo;
